import React = require("react")
import { CollectionType } from "../../../../custom_api/bookarang/types"
import { Link } from "../../library/link"

const selectorId = "inspiration-base-selector"

export const InspirationBaseSelector = (props: { activeBase: CollectionType, routePath: string, labels: SelectorLabels }) => {
  const { activeBase: active, routePath, labels } = props
  return <div className={`tabs`} id={selectorId}>
    <ul className="tabs__list">
      <li className={`tabs__item ${active == 'book' ? 'active' : 'inactive'}`}>
          <Link className="tabs__link" url={`/${routePath}/boek`}>
            <svg className="tabs__icon" width="24" height="24" aria-hidden="true"><use xlinkHref="#icon--book-open"></use></svg> 
            <span className="tabs__label">{labels.book}</span>
          </Link>
      </li>
      <li className={`tabs__item ${active == 'theme' ? 'active' : 'inactive'}`}>
        <Link className="tabs__link" url={`/${routePath}/thema`}>
          <svg className="tabs__icon" width="22px" height="22px" aria-hidden="true"><use xlinkHref="#icon--tag"></use></svg> 
          <span className="tabs__label">{labels.theme}</span>
        </Link>
      </li>
      <li className={`tabs__item ${active == 'mood' ? 'active' : 'inactive'}`}>
        <Link className="tabs__link" url={`/${routePath}/stemming`}>
          <svg className="tabs__icon" width="23px" height="22px" aria-hidden="true"><use xlinkHref="#icon--smile"></use></svg> 
          <span className="tabs__label">{labels.mood}</span>
        </Link>
      </li>
    </ul>
  </div>
}

export type SelectorLabels = { [n in CollectionType]: string }

export const inspirationLabelsWeb: SelectorLabels = {
  book: 'Aanraders',
  theme: 'Onderwerp',
  mood: 'Sfeer en emotie',
  location: 'Locaties',
  moodgroup: 'Sfeergroepen'
}

export const inspirationLabelsKiosk: SelectorLabels = {
  book: 'Meer boeken zoals...',
  theme: 'Zoek op onderwerp',
  mood: 'Zoek op sfeer of emotie',
  location: 'Locaties',
  moodgroup: 'Sfeergroepen'
}